import { Outlet } from "react-router-dom";

export function PaddedLayout() {
  return (
    <div className="tw:flex-1 tw:flex tw:overflow-y-auto tw:p-4 tw:h-screen">
      <Outlet />
    </div>
  );
}
